import { useState, useEffect } from 'react'

import type { Workout } from 'services/workouts/types'
import * as workoutsApi from 'services/workouts'
import * as commentsApi from 'services/comments'
import { generateCommentsFullPathUrl } from 'ui-component-library/utils/helpers'

type Params = {
  date: Date
  isPreview: boolean
  fullPath: string
}

function useWorkout({ date, isPreview, fullPath }: Params) {
  const [isLoading, setIsLoading] = useState(true)
  const [workout, setWorkout] = useState<Workout | null>(null)
  const [commentsCount, setCommentsCount] = useState<number>()

  useEffect(() => {
    if (workout && workout.topicId) {
      commentsApi.fetchCommentsCount(workout.topicId).then(setCommentsCount)
    }
  }, [workout])

  useEffect(() => {
    workoutsApi.fetchWorkout({ date, isPreview }).then((w) => {
      setWorkout(w)
      setIsLoading(false)
    })
  }, [date])

  return {
    isLoading,
    workout,
    commentsCount,
    commentsUrl: workout
      ? generateCommentsFullPathUrl({ fullPath, topicId: workout.topicId })
      : undefined,
  }
}

export default useWorkout
